/**
 * @description Extremely performant generation of a random id
 * @returns {string}
 */
export const quickGuid = (): string => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};
